export const AUTH_API_TOKEN_NAME = 'AUTH_API';
export const ID_TOKEN_HEADER_NAME = 'x-identity-provider-token';

export const DefaultAuthApiConfig = { useStorage: false, useUnauthorizedInterceptor: false };
